import DeleteApprovalClaimModal from './DeleteApprovalClaimModal'

export default DeleteApprovalClaimModal
